import React from "react";
import { useState } from "react";

export default function ({
  label,
  name,
  register,
  errorMessage = "",
  classes = "",
  parentClasses = "",
  disabled = false,
  required = false
}) {

  return (
    <>
      <div className={`fv-row mb-10 switch${parentClasses ? " " + parentClasses : ''}`}>
        <label className="form-check form-switch form-check-custom form-check-solid">
          <input
            className={`form-check-input${classes ? " " + classes : ''}`}
            type="checkbox"
            value="1"
            label="My Value"
            {...register(name)}
            disabled={disabled}
            required={required}
          />
          <span className="form-check-label fw-bold text-muted">{label}</span>
          {required && (<span className="text-danger fw-bolder fs-6"> *</span>)}
        </label>

        {errorMessage && (
          <div className="fv-plugins-message-container invalid-feedback">
            <div>{errorMessage}</div>
          </div>
        )}
      </div>
    </>
  );
}